import { Pipe, PipeTransform } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { isObservable, Observable, of } from 'rxjs';
import _ from 'lodash';
import { faQuestionSquare } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeEngineService } from '../../services/icons/font-awesome-engine.service';
import { map, switchMap } from 'rxjs/operators';

@Pipe({
   name: 'iconNameToIconDefinition$',
})
export class IconNameToIconDefinitionPipe implements PipeTransform {
   constructor(private fontIconService: FontAwesomeEngineService) {}

   transform(iconNameValue: string | Observable<string>): Observable<IconDefinition> {
      let iconNameValue$: Observable<string>;
      if (isObservable(iconNameValue)) {
         iconNameValue$ = iconNameValue as Observable<string>;
      } else {
         iconNameValue$ = of(iconNameValue);
      }

      return iconNameValue$.pipe(
         switchMap((value) =>
            this.fontIconService.icons$.pipe(
               map((icons) => {
                  const icon = icons.find((x) => x.iconName === value);
                  if (_.isNil(icon)) {
                     return faQuestionSquare;
                  }
                  return icon;
               })
            )
         )
      );
   }
}
